import { IAdminsState } from 'store/admins/types';

export const initialState: IAdminsState = {
  data: { admin_users: [] },
  adminDetail: null,
  OBCheck: null,
  selectedRecipient: null,
  recipients: null,
  partners: null,
  isLoading: false,
  screenLoading: false,
  error: null,
  stripeOnboardingCalled: false,
  activeRole: '',
};
